export default __webpack_public_path__ + "static/media/printing-block3.cc1ab23b.png";